import React, { Component } from 'react';
import { Card } from 'react-bootstrap';

class ClientesConsumoInfo extends Component {
  render() {
    const { total = [], cliente = {} } = this.props;

    return (
      <Card>
        <Card.Body>
          <strong className="text-black card-label-info">Cliente: </strong>
          {!!cliente ? cliente.razon_social : 'Todos'}
          <hr />

          <strong className="text-black card-label-info">Comprobantes: </strong>
          {total['comprobantes']}
          <br />

          <strong className="text-black card-label-info">Cancelaciones: </strong>
          {total['cancelaciones']}
          <br />

          <strong className="text-black card-label-info">Retenciones: </strong>
          {total['retenciones']}
          <br />
        </Card.Body>
      </Card>
    );
  }
}

export default ClientesConsumoInfo;
